/* Copyright 2021, Milkdown by Mirone. */
import twemoji from 'twemoji';
export const parse = (emoji) => twemoji.parse(emoji, { attributes: (text) => ({ title: text }) });
//# sourceMappingURL=parse.js.map